<template>
  <div>
    <AppHead />
    <SectionContainer v-show="!isGuest">
      <h2 class="text-center text-secondary mb-5 pb-5">Mes questionnaires</h2>
      <div class="">
        <div v-if="surveys.length === 0" class="text-center mt-3">
          Vous n'avez présentement aucun questionnaire.
        </div>
        <UserSurveyRow
          v-for="survey of surveys"
          :key="survey.id"
          :survey="survey"
          :errors="errors"
        />
      </div>
      <div class="d-flex w-100 content-center">
        <button class="btn btn-primary m-2" @click="showModal = true">
          Importer à partir d'un code
        </button>
        <button class="btn btn-primary m-2" @click="startNewSurvey">
          Nouveau questionnaire
        </button>
      </div>

      <SurveyImportModal
        :show-modal="showModal"
        @closeModal="showModal = false"
      />
    </SectionContainer>
  </div>
</template>

<script>
import SurveyImportModal from '../Components/SurveyImportModal.vue'
import UserSurveyRow from '../Components/UserSurveyRow.vue'
import App from '../Layouts/App'

export default {
  components: { SurveyImportModal, UserSurveyRow },
  layout: App,
  props: {
    errors: {
      type: Object,
      default() {
        return {}
      },
    },
    surveys: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    }
  },
  computed: {
    isGuest() {
      return this.$page.props.is_guest
    },
  },
  beforeCreate() {
    if (this.$page.props.is_guest) {
      this.$inertia.visit(this.$route('survey.index'))
    }
  },
  methods: {
    startNewSurvey() {
      return this.$inertia.visit(this.$route('survey.start'))
    },
  },
}
</script>
